<template>
  <o-input-location
    :value="location"
    label="Localisation*"
    lazy
    :coordinate-format="coordinateFormat"
    @input="input"
  />
</template>

<script>
import OInputLocation from '@components/InputLocation.vue'
import { FORMAT_DD, FORMAT_DDM, FORMAT_DMS } from '@filters/coordinate'

export default {
  name: 'LocationField',

  components: { OInputLocation },

  props: {
    location: {
      type: Array,
      required: true,
    },
    coordinateFormat: {
      type: String,
      required: true,
      validator: (v) => [FORMAT_DD, FORMAT_DDM, FORMAT_DMS].indexOf(v) !== -1,
    },
  },

  data() {
    return {
      error: null,
    }
  },

  methods: {
    input(input) {
      this.error = input.hasError ? 'Format invalide' : null

      this.$emit('error', input.hasError)

      if (!input.hasError) {
        this.$emit('update:location', input.latLng)
      }
    },
  },
}
</script>
